import { toast } from "react-toastify";
import SidebarField from "../../../components/Sidebar/SidebarField";
import { FormField } from "../../../components/FormField";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { IoMdAddCircleOutline, IoMdRemoveCircleOutline } from "react-icons/io";
import { InventoryApi } from "../../../apis/inventory.api";
import * as Yup from "yup";
import { productApi } from "../../../apis/ProductListing.apis";
import { useContext, useEffect, useState } from "react";
import LoaderContext from "../../../components/loader";
import SelectDropdown from "../../../components/Dropdown/SelectDropdown";
import Textarea from "../../../components/Textarea";
import masterApi from "../../../apis/master.api";

const goodReceiptVoucherValidationSchema = Yup.object({
  dateOfReceipt: Yup.string()
    .required("Date of receipt is required")
    .nullable(),
  receivedFrom: Yup.string().required("Received from is required"),
  orderReference: Yup.string().nullable(),
  vendorLocation: Yup.string().nullable(),
  receivedBy: Yup.string().nullable(),
  itemDetails: Yup.array()
    .of(
      Yup.object({
        itemCode: Yup.string().required("Item code is required"),
        itemDescription: Yup.string().required("Item description is required"),
        quantity: Yup.number()
          .required("Quantity is required")
          .positive("Quantity must be greater than zero")
          .integer("Quantity must be an integer"),
        unit: Yup.string().required("Unit is required"),
        conditionOfGoods: Yup.string().required(
          "Condition of goods is required"
        ),
        unitCost: Yup.number()
          .required("Unit cost is required")
          .positive("Unit cost must be greater than zero"),
        totalCost: Yup.number()
          .required("Total cost is required")
          .positive("Total cost must be greater than zero"),
        comments: Yup.string().nullable(),
      })
    )
    .min(1, "At least one item is required")
    .required("Item details are required"),
});

function AddGRV({ open, handleClose, data, getAllGRV }) {
  const { handleLoading } = useContext(LoaderContext);
  const [allProducts, setAllProducts] = useState([]);
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [unitMasterData, setUnitMasterData] = useState(false);

  const [productPagination, setProductPagination] = useState({
    page: 1,
    limit: 8,
    sortOrder: "desc",
    filter: {},
    totalPages: 1,
    totalCount: 5,
  });
  const initialValues = {
    dateOfReceipt: data?.dateOfReceipt || "",
    receivedFrom: data?.receivedFrom || "",
    orderReference: data?.orderReference || "",
    vendorLocation: data?.vendorLocation || "",
    receivedBy: data?.receivedBy || "",
    attachments: data?.attachments || null,
    itemDetails: data?.itemDetails?.map((item) => ({
      itemCode: item.itemCode || "",
      itemDescription: item.itemDescription || "",
      quantity: item.quantity || "",
      unit: item.unit || "",
      conditionOfGoods: item.conditionOfGoods || "",
      unitCost: item.unitCost || "",
      totalCost: item.totalCost || "",
      comments: item.comments || "",
    })) || [
      {
        itemCode: "",
        itemDescription: "",
        quantity: 0,
        unit: "",
        conditionOfGoods: "",
        unitCost: "",
        totalCost: "",
        comments: "",
      },
    ],
  };

  const getAllProducts = async () => {
    handleLoading(true);
    try {
      const res = await productApi.getAllProductsWithoutFilter();
      setAllProducts(res.data?.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const res = data
        ? await InventoryApi.updateGRV(data?._id, values)
        : await InventoryApi.createGRV(values);
      toast.success("GRV updated successfully");
      getAllGRV();
      resetForm();
    } catch (error) {
      console.error("Error while adding GRV:", error);
      toast.error(error?.message);
    }
    handleClose();
  };

  const getAllUnitMaster = async () => {
    handleLoading(true);
    try {
      const res = await masterApi.getAllUnitMaster({});
      const data = res?.data?.data?.map((item) => ({
        name: item?.unit,
        _id: item?._id,
      }));

      setUnitMasterData(data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    getAllProducts();
    getAllUnitMaster();
  }, []);

  const handleFieter = (id) => {
    return allProducts?.find((p) => p?._id === id);
  };

  if (open) {
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={goodReceiptVoucherValidationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <SidebarField
              handleClose={handleClose}
              title={
                data
                  ? "Update Goods Receipt Voucher (GRV)"
                  : "Add Goods Receipt Voucher (GRV)"
              }
              button1={
                <Button text="Cancel" type="button" onClick={handleClose} />
              }
              button2={<Button text="Submit" type="submit" />}
              setHeaderWdith={setIsFullWidth}
            >
              <div className="w-full gap-4 flex flex-col bg-transparent py-2 px-2">
                <div
                  className={`grid  ${
                    isFullWidth ? "gap-6 grid-cols-2 p-6" : "grid-cols-1 gap-3"
                  }`}
                >
                  {data && (
                    <div className="w-full lg:w-1/3 flex-grow">
                      <FormField label="Receipt Number">
                        <TextInput
                          name="receiptNumber"
                          value={data?.receiptNumber || values.receiptNumber}
                          onChange={handleChange}
                          disabled={"disabled"}
                        />
                        <ErrorMessage
                          name="receiptNumber"
                          component="div"
                          className="error"
                        />
                      </FormField>
                    </div>
                  )}
                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Date of Receipt">
                      <TextInput
                        name="dateOfReceipt"
                        type="date"
                        value={data?.dateOfReceipt || values.dateOfReceipt}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="dateOfReceipt"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>

                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Received From">
                      <TextInput
                        name="receivedFrom"
                        value={data?.receivedFrom || values.receivedFrom}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="receivedFrom"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>
                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Order Reference">
                      <TextInput
                        name="orderReference"
                        value={data?.orderReference || values.orderReference}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="orderReference"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>
                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Vendor Location">
                      <TextInput
                        name="vendorLocation"
                        value={data?.vendorLocation || values.vendorLocation}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="vendorLocation"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>
                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Received By">
                      <TextInput
                        name="receivedBy"
                        value={data?.receivedBy || values.receivedBy}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="receivedBy"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>
                  {/* Attachments */}
                  <div className="w-full lg:w-1/3 flex-grow">
                    <FormField label="Attachments">
                      <TextInput
                        name="attachments"
                        type="file"
                        onChange={(e) => {
                          setFieldValue("attachments", e.target.files[0]);
                        }}
                        // multiple
                      />
                      <ErrorMessage
                        name="attachments"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  </div>
                </div>

                {/* Item Details Array */}

                <FieldArray name="itemDetails">
                  {({ push, remove }) => (
                    <div className="overflow-y-auto border rounded p-4">
                      <table className="w-full text-left border-collapse">
                        <thead>
                          <tr>
                            <th className="border-b p-2">Item</th>
                            <th className="border-b p-2">Item Code</th>
                            <th className="border-b p-2">Item Description</th>
                            <th className="border-b p-2">Quantity</th>
                            <th className="border-b p-2">Unit</th>
                            {/* <th className="border-b p-2">Batch Number</th> */}
                            <th className="border-b p-2">Condition of Goods</th>
                            <th className="border-b p-2">Unit Cost</th>
                            <th className="border-b p-2">Total Cost</th>
                            <th className="border-b p-2">Comments</th>
                            <th className="border-b p-2">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.itemDetails.map((item, index) => (
                            <tr key={index} className="border-b">
                              <td className="p-2 font-semibold">
                                Item {index + 1}
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.itemCode`}
                                  as={SelectDropdown}
                                  options={allProducts}
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Item Code"
                                  sx={{
                                    width: "20px",
                                    borderRadius: "12px",
                                    backgroundColor: "lightgray",
                                  }}
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.itemCode`,
                                      v
                                    );
                                    let item = handleFieter(v);

                                    setFieldValue(
                                      `itemDetails.${index}.itemDescription`,
                                      item?.description
                                        ? item?.description.replace(
                                            /<[^>]*>/g,
                                            ""
                                          )
                                        : ""
                                    );

                                    setFieldValue(
                                      `itemDetails.${index}.unit`,
                                      item?.description
                                    );
                                    setFieldValue(
                                      `itemDetails.${index}.itemDescription`,
                                      item?.description
                                    );
                                    setFieldValue(
                                      `itemDetails.${index}.itemDescription`,
                                      item?.description
                                    );
                                  }}
                                ></Field>
                                <ErrorMessage
                                  name={`itemDetails.${index}.itemCode`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-3">
                                <div className="relative">
                                  {values.itemDetails[index].itemDescription ? (
                                    <div
                                      className="border rounded text-ellipsis p-2 bg-gray-50 min-h-[60px] max-h-[120px] overflow-y-auto overflow-x-hidden text-sm"
                                      dangerouslySetInnerHTML={{
                                        __html: values.itemDetails[index].itemDescription
                                      }}
                                    />
                                  ) : (
                                    <Textarea
                                      name={`itemDetails.${index}.itemDescription`}
                                      value={values.itemDetails[index].itemDescription}
                                      onChange={handleChange}
                                      placeholder="Item description will appear here when item is selected"
                                      className="w-full min-h-[60px] text-sm"
                                      disabled={true}
                                    />
                                  )}
                                </div>
                                <ErrorMessage
                                  name={`itemDetails.${index}.itemDescription`}
                                  component="div"
                                  className="error text-red-500 text-xs mt-1"
                                />
                              </td>

                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.quantity`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.quantity`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.unit`}
                                  as={SelectDropdown}
                                  options={unitMasterData}
                                  optionLabel="unit"
                                  optionValue="_id"
                                  placeholder="Select unit"
                                  className="w-24 border p-2 "
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.unit`,
                                      v
                                    );
                                  }}
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.unit`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              {/* <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.batchNumber`}
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.batchNumber`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td> */}
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.conditionOfGoods`}
                                  as={SelectDropdown}
                                  options={[
                                    { name: "grade 1", _id: "grade1" },
                                    { name: "grade 2", _id: "grade2" },
                                    { name: "grade 3", _id: "grade3" },
                                    { name: "grade 4", _id: "grade4" },
                                    { name: "grade 5", _id: "grade5" },
                                  ]}
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Grade"
                                  className="w-24 border p-2 "
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.conditionOfGoods`,
                                      v
                                    );
                                  }}
                                ></Field>

                                <ErrorMessage
                                  name={`itemDetails.${index}.conditionOfGoods`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.unitCost`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.unitCost`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.totalCost`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.totalCost`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.comments`}
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.comments`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2 flex justify-center items-center gap-2">
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    remove(index);
                                  }}
                                  type="button"
                                  disabled={index === 0 && "disabled"}
                                  className={`${
                                    index === 0
                                      ? "cursor-not-allowed"
                                      : "cursor-pointer"
                                  } text-red500 hover:text-red700`}
                                >
                                  <IoMdRemoveCircleOutline
                                    style={{ fontSize: "1.5rem" }}
                                  />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();

                                    push({
                                      itemCode: "",
                                      itemDescription: "",
                                      quantity: "",
                                      unit: "",
                                      batchNumber: "",
                                      conditionOfGoods: "",
                                      unitCost: "",
                                      totalCost: "",
                                      comments: "",
                                    });
                                  }}
                                  type="button"
                                  className="text-green500 hover:text-green700"
                                >
                                  <IoMdAddCircleOutline
                                    style={{ fontSize: "1.5rem" }}
                                  />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </FieldArray>
              </div>
            </SidebarField>
          </Form>
        )}
      </Formik>
    );
  }
  return null;
}

export default AddGRV;